var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCandadoCerrado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icono_proteccion",
    "data-name": "Icono proteccion",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_72",
    "data-name": "Rect\\xE1ngulo 72",
    width: 26,
    height: 26,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_349",
    "data-name": "Grupo 349",
    transform: "translate(-0.001 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "lock_FILL0_wght300_GRAD0_opsz40",
    d: "M181.445-862a1.389,1.389,0,0,1-1.018-.425,1.39,1.39,0,0,1-.425-1.019v-9.044a1.388,1.388,0,0,1,.425-1.021,1.394,1.394,0,0,1,1.018-.423h1.438v-2.027a3.9,3.9,0,0,1,1.18-2.862,3.9,3.9,0,0,1,2.863-1.18,3.893,3.893,0,0,1,2.861,1.18,3.9,3.9,0,0,1,1.178,2.862v2.027H192.4a1.394,1.394,0,0,1,1.018.423,1.388,1.388,0,0,1,.425,1.021v9.044a1.39,1.39,0,0,1-.425,1.019A1.389,1.389,0,0,1,192.4-862Zm0-1.16H192.4a.276.276,0,0,0,.2-.08.277.277,0,0,0,.08-.2v-9.044a.276.276,0,0,0-.08-.2.276.276,0,0,0-.2-.08H181.445a.276.276,0,0,0-.2.08.276.276,0,0,0-.08.2v9.044a.277.277,0,0,0,.08.2A.276.276,0,0,0,181.445-863.157Zm5.482-3.225a1.528,1.528,0,0,0,1.117-.458,1.5,1.5,0,0,0,.462-1.1,1.565,1.565,0,0,0-.464-1.116,1.5,1.5,0,0,0-1.119-.484,1.487,1.487,0,0,0-1.117.484,1.578,1.578,0,0,0-.462,1.124,1.485,1.485,0,0,0,.464,1.1A1.537,1.537,0,0,0,186.927-866.382Zm-2.884-7.547h5.763v-2.027a2.78,2.78,0,0,0-.84-2.041,2.776,2.776,0,0,0-2.04-.841,2.783,2.783,0,0,0-2.042.841,2.776,2.776,0,0,0-.842,2.041Zm-2.882,10.772v0Z",
    transform: "translate(-174.002 882.996)",
    fill: "#e7e7e7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandadoCerrado);
export default __webpack_public_path__ + "static/media/candado-cerrado.4bb22c45586bbc1a3701b0c0d0c2c02a.svg";
export { ForwardRef as ReactComponent };